import { StringParam } from 'use-query-params';

import { JobFilters } from 'api/jobs';
import { DatasetTab } from 'components/StudyDashboard/useStudyDashboardTabState';
import { filtersQueryParamsSchema } from './useEncodedFilters/constants';
import { encodeQueryParamsUsingSchema } from './useEncodedFilters/helpers';

export interface DatasetTabSlideFilterUrlProps {
  studyId: string;
  labId?: string;
  slideIds: string[];
  // Optional job statuses to scope the Dataset case/slide job filter to (e.g. ['failed']).
  // Without this, the link only narrows by slideIds.
  statuses?: string[];
}

// The Dataset tab does not filter its grid from a raw slideIdsToInclude list alone. It filters
// cases/slides through datasetJobFilters, which is mapped to the procedures API jobsFilters field.
// Jobs-tab jobsFilters must not be reused here.
const getSearchStringForDatasetTabSlideFilter = ({
  studyId,
  labId,
  slideIds,
  statuses,
}: DatasetTabSlideFilterUrlProps): string =>
  encodeQueryParamsUsingSchema(
    {
      filters: { studyId },
      labId,
      slidesMode: true,
      datasetJobFilters: { studyId, slideIds, ...(statuses ? { statuses } : {}) } as JobFilters,
      datasetJobFiltersIncludeExclude: 'include',
      studyDashboardTab: DatasetTab,
    },
    {
      ...filtersQueryParamsSchema,
      studyDashboardTab: StringParam,
    }
  );

export const getLinkToDatasetTabForSlideIds = (props: DatasetTabSlideFilterUrlProps) => {
  const encodedParams = getSearchStringForDatasetTabSlideFilter(props);

  return {
    pathname: `/procedures`,
    search: `?${encodedParams}`,
    hash: '',
  };
};

export const getUrlToDatasetTabForSlideIds = (props: DatasetTabSlideFilterUrlProps) => {
  const linkToDatasetTab = getLinkToDatasetTabForSlideIds(props);
  return `${linkToDatasetTab.pathname}${linkToDatasetTab.search}`;
};
